import { postFileAttachment } from '@/services/attachments.service'

type UploadableFile = {
  file: File
  id: string
  url: string
  status: string | null | boolean
}

export async function uploadFile(file: UploadableFile, entityId: string, entityType: string) {
  if (file.status === true || file.status === 'loading') return
  file.status = 'loading'
  const response = await postFileAttachment(entityId, file.file, entityType)
    .then((data) => {
      if (data.status === 200) {
        file.status = true
      } else {
        file.status = false
      }
    })
    .catch((e) => {
      console.error(e)
      file.status = false
    })
  return response
}

export async function uploadFiles(
  filesUpload: UploadableFile[],
  entityId: string,
  entityType: string
) {
  // Delay seems necessary for backend to handle multiple files properly
  // Without delay, one or some files were randomly not uploaded even if the promise was resolved
  let delay = 0
  const delayIncrement = 500
  const promises = filesUpload.map((file) => {
    delay += delayIncrement
    return new Promise((resolve) => setTimeout(resolve, delay)).then(() =>
      uploadFile(file, entityId, entityType)
    )
  })
  return await Promise.all(promises)
  // Revert to old method below if necessary
  // return Promise.all(filesUpload.map((file) => uploadFile(file, entityId)))
}

export default function createFileUploader() {
  return {
    uploadFile: function (file: UploadableFile, entityId: string, entityType: string) {
      return uploadFile(file, entityId, entityType)
    },
    uploadFiles: function (filesUpload: UploadableFile[], entityId: string, entityType: string) {
      return uploadFiles(filesUpload, entityId, entityType)
    }
  }
}
